import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-final-form';

import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsDocumentCapture';
import { isApplicationNonProd } from 'Utilities/helpers';
import { safeLocalStorage } from 'Utilities/storages';

import { AddBankDetailsModal } from './AddBankDetailsModal/AddBankDetailsModal';
import { AccountHolderName } from './fields/AccountHolderName';
import { AccountNumber } from './fields/AccountNumber';
import AccountType from './fields/AccountType';
import { SortCode } from './fields/SortCode';
import { ADD_BANK_DETAILS_ACTION_TYPE } from './AddBankDetails.helpers';
import { BeneficiaryValues } from './AddBankDetails.types';
import { AddBankDetailsContext, AddBankDetailsContextType } from './AddBankDetailsContext';
import { AddBankDetailsFormButtons } from './AddBankDetailsFormButtons';

type AddBankDetailsProps = {
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<object | undefined> | undefined;
  onSubmitCallback: (values: BeneficiaryValues) => Promise<void>;
}

export const AddBankDetailsForm = ({ handleSubmit, onSubmitCallback }: AddBankDetailsProps) => {
  const [showModal, setShowModal] = useState(false);
  const { action, index }: AddBankDetailsContextType = useContext(AddBankDetailsContext);

  const copNotEnrolledActive = isApplicationNonProd && safeLocalStorage.getItem('copNotEnrolled');

  const { restart } = useForm();

  const shouldRestart = action === ADD_BANK_DETAILS_ACTION_TYPE.CLEAR;

  const openModal = () => {
    DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS.BANK_DETAILS_OVERLAY_OPENED();
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  useEffect(() => {
    if (shouldRestart) {
      restart();
    }
  }, [index, restart, shouldRestart]);

  return (
    <form
      noValidate
      onSubmit={handleSubmit}
    >
      <AccountHolderName data-cy='accountHolderName'/>
      <AccountNumber data-cy='accountNumber'/>
      <SortCode data-cy='accountSortCode'/>
      <AccountType data-cy='accountSortType'/>
      {copNotEnrolledActive && <>
        <br />
        <InfoBox content="CoP not_enrolled simulateCode is active" variant="warning"/>
      </>}
      <AddBankDetailsFormButtons openContinueModal={openModal} />
      {showModal && (
        <AddBankDetailsModal
          onCloseCallback={closeModal}
          {...{ onSubmitCallback }}
        />
      )}
    </form>
  );
};
